import { render } from "./WorkshopsView.vue?vue&type=template&id=12a44bd8"
import script from "./WorkshopsView.vue?vue&type=script&lang=js"
export * from "./WorkshopsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__